import React, {useState, useEffect} from 'react';
import Axios from 'axios'
import { CATviewWrapper } from '../CATviewWrapper/CATviewWrapper';
import { runQuery, sigmoid, getlevenshteinDistance } from '../utils'
import { getMsAndTs } from './queries'
import { textClean } from 'ngram-diff';
import { Spinner } from '../Spinner/Spinner';
import { CollationTable } from '../CollationTable/CollationTable';

export interface MyComponentProps {
  // Define your prop types here
  expressionid: string
}

export const CATviewCompare: React.FC<MyComponentProps> = (props) => {

  const [mslug] = useState<string>(""); 
  const [edges, setEdges] = useState<any[]>([]);
  const [edgeNames, setEdgeNames] = useState<any[]>([]);
  const [witNames, setWitNames] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false)
  const [focusBlockId, setFocusBlockId] = useState<string>("")
  
  const defaultManifestationSlug = mslug || "";

  useEffect(() => {
    createEdges()
  }, [props.expressionid])


  const handleOnClick = (wit: any, edge: any) => {
    console.log("wit", wit)
    console.log("edge", edge)
    const blockid: string = edgeNames[edge]
    // const blockTid: string = edgeCts[edge]
    // const compareid: string = witNames[wit - 1]
    // const compareTid: string = witCts[compareid]
    // setFocusBlockTid(blockTid)
    // setFocusCompareTid(compareTid)
    // setFocusBlockEid(blockid)
    // setFocusCompareEid(compareid)
    setFocusBlockId(blockid)
    //console.log('bid', blockid)
    
    //setDisplayText("blockid: " + blockid + " compareid: " + compareid)
  }


  const createEdges = () => {
    const queryString = getMsAndTs(props.expressionid || "http://scta.info/resource/lectio1")
    const queryResults = runQuery(queryString)
    
    queryResults.then((d: any) => {
      setLoading(true)
      setWitNames([])
      setEdgeNames([])
      setEdges([])
      const results = d.data.results.bindings
        const promiseArray = results.map(function(r: any){
          var textPromise = new Promise(function(resolve){
            var urlSlug = r.mt.value.split("http://scta.info/resource/")[1]
            Axios.get("https://exist.scta.info/exist/apps/scta-app/csv/" + urlSlug + "?format=json").then((text) => {
              const mHash: any = {
                id: r.mt.value, 
                canonical: r.mt.value === r.cmt.value ? true : false,
                blocks: {}
              }
              if (text.data){
                text.data.forEach((r: any) => {
                mHash.blocks[r.block] = textClean(r.text)
                })
              }
              resolve(mHash)
            });
          });
          return textPromise
        });

        const resourceid = props.expressionid
        if (resourceid.includes("plaoulcommentary") || resourceid.includes("pp-") || resourceid.includes("lectio")){
        //// custom promises to add known "RelatedToTexts for Plaoul reportatio"
        var erlangPromise = new Promise(function(resolve){
            let url = ""
            if (resourceid.includes("plaoulcommentary")){
              url = "http://scta.info/resource/plaoulreportatio/erlang/transcription"
            }
            else if (resourceid.includes("pp-")) {
              url = "http://scta.info/resource/ppr-" + resourceid.split("-")[1] + "/erlang/transcription"
            }
            else if (resourceid.includes("lectio")) {
              url = "http://scta.info/resource/ppr-" + resourceid + "/erlang/transcription"
            }
            var urlSlug = url.split("http://scta.info/resource/")[1]
            Axios.get("https://exist.scta.info/exist/apps/scta-app/csv/" + urlSlug + "?format=json").then((text) => {
            // $.get("https://exist.scta.info/exist/apps/scta-app/csv/" + urlSlug + "?format=json", function(data){
              const mHash: any = {
                id: url,
                canonical: false,
                blocks: {}
              }
              if (text.data){
                text.data.forEach((t: any) => {
                mHash.blocks[t.block] = textClean(t.text)
                })
              }
              resolve(mHash)
            });
          });
        
          promiseArray.push(erlangPromise)          

        var palPromise = new Promise(function(resolve){
          let url = ""
          if (resourceid.includes("plaoulcommentary")){
              url = "http://scta.info/resource/plaoulreportatio/pal/transcription"
            }
            else if (resourceid.includes("pp-")) {
              url = "http://scta.info/resource/ppr-" + resourceid.split("-")[1] + "/pal/transcription"
            }
            else if (resourceid.includes("lectio")) {
              url = "http://scta.info/resource/ppr-" + resourceid + "/pal/transcription"
            }
            var urlSlug = url.split("http://scta.info/resource/")[1]
            Axios.get("https://exist.scta.info/exist/apps/scta-app/csv/" + urlSlug + "?format=json").then((text) => {
            //$.get("https://exist.scta.info/exist/apps/scta-app/csv/" + urlSlug + "?format=json", function(data){
              const mHash: any = {
                id: url, 
                canonical: false,
                blocks: {}
              }
              if (text.data){
                text.data.forEach((t: any) => {
                mHash.blocks[t.block] = textClean(t.text)
                })
              }
              resolve(mHash)
            });
          });
        
          promiseArray.push(palPromise)    
          
          var bnf3074Promise = new Promise(function(resolve){
            let url = ""
            if (resourceid.includes("plaoulcommentary")){
              url = "http://scta.info/resource/plaoulreportatioA/bnf3074/transcription"
            }
            else if (resourceid.includes("pp-")) {
              url = "http://scta.info/resource/ppra-" + resourceid.split("-")[1] + "/bnf3074/transcription"
            }
            else if (resourceid.includes("lectio")) {
              url = "http://scta.info/resource/ppra-" + resourceid + "/bnf3074/transcription"
            }
            var urlSlug = url.split("http://scta.info/resource/")[1]
            Axios.get("https://exist.scta.info/exist/apps/scta-app/csv/" + urlSlug + "?format=json").then((text) => {
            // $.get("https://exist.scta.info/exist/apps/scta-app/csv/" + urlSlug + "?format=json", function(data){
              const mHash: any = {
                id: url, 
                canonical: false,
                blocks: {}
              }
              if (text.data){
                text.data.forEach((t: any) => {
                mHash.blocks[t.block] = textClean(t.text)
                })
              }
              resolve(mHash)
            });
          });
        
          promiseArray.push(bnf3074Promise) 

        }



        
        
        Promise.all(promiseArray).then(function(values){
          const witNamesArray: any[] = []
          
          const crit = (values.find((i) => {
            if (defaultManifestationSlug){
              if (i.id === props.expressionid + "/" + defaultManifestationSlug + "/transcription"){
                return i
              }

            }
            else if (i.canonical === true){
              return i
            }

          }))

          
          //setWitNames([...witNames, crit.id.split("/resource/")[1].split("/")[1]])
          witNamesArray.push(crit.id.split("/resource/")[1].split("/")[1])
          
          const nonCrit: any[] = []
            values.forEach((i) => {
              if (defaultManifestationSlug){
                if (i.id !== props.expressionid + "/" + defaultManifestationSlug + "/transcription"){
                  nonCrit.push(i)
                  //setWitNames([...witNames, i.id.split("/resource/")[1].split("/")[1]])
                  witNamesArray.push(i.id.split("/resource/")[1].split("/")[1])  
                }
              }
              else if (i.canonical === false){
                nonCrit.push(i)
                //setWitNames([...witNames, i.id.split("/resource/")[1].split("/")[1]])
                witNamesArray.push(i.id.split("/resource/")[1].split("/")[1])
              }
            })
          const scoresArray1: any[] = []
          const edgeNamesArray: any[] = []
          Object.keys(crit.blocks).forEach((b) => {
            // if any base text paragraph contains the word omitted convert it to an empty string
            const baseText = textClean(crit.blocks[b]).includes("omitted") ? "" : textClean(crit.blocks[b])
            
            // if any base text paragraph has any empty string consider it not existent (-1) other consider it to have no variation (0)
            const baseScore = baseText === "" ? -1 : 0
            const scoresArray2: any[] = []
            scoresArray2.push(baseScore)
            //  console.log("b", b)
            //  edgeNamesArray.push(b)
            
            nonCrit.forEach((nc) => {
              
              let score 
              /// the first condition records a does not exist if the matching paragraph does not exist 
              // OR if the paragraph exist but has the word "omitted" inside. (Sometimes I write "omitted" temporarily instead of deleting the paragraph in order to keep alignment
              // TODO: there are likely also some cases where the paragraph exist but NO text is present; this is nto handled yet)
              if (nc.blocks[b] && !(nc.blocks[b].toLowerCase().includes("omitted") || nc.blocks[b].toLowerCase().includes("Omitted"))){
                score = getlevenshteinDistance(baseText.toLowerCase(), nc.blocks[b].toLowerCase())
              }
              // this conditional is just for plaoulcommentary and plaoulreportatio match up 
              else if (nc.blocks["http://scta.info/resource/ppr-" + b.split("/resource/")[1]]){
                score = getlevenshteinDistance(baseText.toLowerCase(), nc.blocks["http://scta.info/resource/ppr-" + b.split("/resource/")[1]].toLowerCase())
              }
              // this conditional is just for plaoulcommentary and plaoulreportatioA match up 
              else if (nc.blocks["http://scta.info/resource/ppra-" + b.split("/resource/")[1]]){
                score = getlevenshteinDistance(baseText.toLowerCase(), nc.blocks["http://scta.info/resource/ppra-" + b.split("/resource/")[1]].toLowerCase())
              }
              else{
                 score = -1
              }
              scoresArray2.push(score)
              

            })
            
            scoresArray1.push(scoresArray2)
            edgeNamesArray.push(b)
            
          })

          //begin to set State
          setLoading(false)
          setWitNames(witNamesArray)

          // scale the scores with a sigmoid function
          const sigmoidScoresArray: any[] = scoresArray1.map((e) => {
              return e.map((i: any) => {
                return sigmoid(i)
                
              })
            })
          setEdges(sigmoidScoresArray)
          setEdgeNames(edgeNamesArray)
        })
      })
  }

  
  return (
    <div>
      {loading 
      ? <Spinner/> :
      <>
      <CATviewWrapper names={witNames} edges={edges} edgeNames={edgeNames} parentHandleOnClick={handleOnClick}/>
      {focusBlockId && <CollationTable expressionIds={[focusBlockId]}/>}
      </>
      }
    </div>
  )
}
